<template>
    <select
        :value="modelValue"
        class="bg-[#1e1e1e] border-[#474849] border-[1px] pl-[10px] text-white text-[14px] w-[100%] py-[3px] px-[5px] rounded-[6px]"
        :class="selectClass"
        @change="$emit('update:modelValue', $event.target.value)"
    >
        <option value="" disabled>{{ placeholder }}</option>
        <optgroup
            v-for="entry in folders"
            :key="entry.folder.id"
            :label="entry.folder.name"
        >
            <option class="text-white" :value="entry.folder.name">
                {{ entry.folder.name }}
            </option>
            <option
                v-for="sub in entry.subfolders"
                :key="sub.id"
                class="text-white"
                :value="sub.name"
            >
                — {{ sub.name }}
            </option>
        </optgroup>
    </select>
</template>

<script>
import { ref, onMounted } from 'vue'
import { getAllTrainingElementFoldersWithSubfolders } from '@/services/apiRequests'

export default {
    name: 'TrainingElementFolderSelect',

    props: {
        modelValue: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: 'Виберіть блок елементів'
        },
        selectClass: {
            type: [String, Object, Array],
            default: ''
        }
    },

    emits: ['update:modelValue'],

    setup() {
        const folders = ref([])

        onMounted(async () => {
            const response = await getAllTrainingElementFoldersWithSubfolders()
            folders.value = Array.isArray(response) ? response : []
        })

        return { folders }
    }
}
</script>
